module.exports = __webpack_public_path__ + "static/djangocon2017-641ffdf927fbf5182fde6f54c399f23e.webp";